// import actionType
import {
  GET_COMPANY_TO_USER_LIST,
  GET_COMPANY_TO_USER_LIST_SUCCESS,
  GET_COMPANY_TO_USER_LIST_FAILURE,
  SWITCH_COMPANY,
  SWITCH_COMPANY_SUCCESS,
  SWITCH_COMPANY_FAILURE,
  GET_COMPANY_USER_INVITATIONS,
  GET_COMPANY_USER_INVITATIONS_SUCCESS,
  GET_COMPANY_USER_INVITATIONS_FAILURE,
  SEND_EMAIL_INVITATION,
  SEND_EMAIL_INVITATION_SUCCESS,
  SEND_EMAIL_INVITATION_FAILURE,
  GET_JOIN_COMPANY_INVITATION_LIST,
  GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS,
  GET_JOIN_COMPANY_INVITATION_LIST_FAILURE,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE,
  GET_COMPANY_TEAM_MEMBERS_LIST,
  GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS,
  GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE,
  GET_COMPANY_DETAILS,
  GET_COMPANY_DETAILS_SUCCESS,
  GET_COMPANY_DETAILS_FAILURE,
  UPDATE_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS_SUCCESS,
  UPDATE_COMPANY_DETAILS_FAILURE,
  GET_USER_AVAILABLE_MENU,
  GET_USER_AVAILABLE_MENU_SUCCESS,
  GET_USER_AVAILABLE_MENU_FAILURE,
  GET_USER_AVAILABLE_DASHBOARD,
  GET_USER_AVAILABLE_DASHBOARD_SUCCESS,
  GET_USER_AVAILABLE_DASHBOARD_FAILURE,
  MAP_DASHBOARD_AND_MENU_TO_USER,
  MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS,
  MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE,
  GET_COMPANY_TO_USER_LIST_TEAM,
  GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS,
  GET_COMPANY_TO_USER_LIST_TEAM_FAILURE,
  UPDATE_COMPANY_TO_USER_TEAM,
  UPDATE_COMPANY_TO_USER_TEAM_SUCCESS,
  UPDATE_COMPANY_TO_USER_TEAM_FAILURE,
  CREATE_COMPANY_TO_USER,
  CREATE_COMPANY_TO_USER_SUCCESS,
  CREATE_COMPANY_TO_USER_FAILURE,
  DELETE_COMPANY_TO_USER,
  DELETE_COMPANY_TO_USER_SUCCESS,
  DELETE_COMPANY_TO_USER_FAILURE,
  COMPANY_TO_USER_LOCK_USER,
  COMPANY_TO_USER_LOCK_USER_SUCCESS,
  COMPANY_TO_USER_LOCK_USER_FAILURE,
  COMPANY_TO_USER_UNLOCK_USER,
  COMPANY_TO_USER_UNLOCK_USER_SUCCESS,
  COMPANY_TO_USER_UNLOCK_USER_FAILURE,
  COMPANY_TO_USER_RESET_PASSWORD,
  COMPANY_TO_USER_RESET_PASSWORD_SUCCESS,
  COMPANY_TO_USER_RESET_PASSWORD_FAILURE,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE,
  GET_COMPANY_TO_USER_DATA,
  GET_COMPANY_TO_USER_DATA_SUCCESS,
  GET_COMPANY_TO_USER_DATA_FAILURE,
} from "./actionType";

// reducer function
const initialState = {
  companyToUserList: [],
  companySwitch: [],
  getCompanySwitchListLoading: false,
  companyUserInvitations: [],
  sendUserInviteSuccess: [],
  sendUserInviteSuccessLoading: false,
  joinCompanyInvitationList: [],
  joinCompanyInvitationListLoading: false,
  acceptOrDeclineInvitationToJoinCompany: [],
  acceptOrDeclineInvitationToJoinCompanyLoading: false,
  companyTeamMembersList: [],
  companyTeamMembersListLoading: false,
  companyDetails: [],
  companyDetailsLoading: false,
  updateCompanyDetailsSuccess: [],
  updateCompanyDetailsLoading: false,
  userAvailableMenu: [],
  userAvailableMenuLoading: false,
  userAvailableDashboard: [],
  userAvailableDashboardLoading: false,
  mapDashboardAndMenuToUser: [],
  mapDashboardAndMenuToUserLoading: false,
  getCompanyToUserListTeam: [],
  getCompanyToUserListTeamLoading: false,
  createCompanyToUserSuccess: [],
  createCompanyToUserLoading: false,
  updateCompanyToUserTeamSuccess: [],
  updateCompanyToUserTeamLoading: false,
  deleteCompanyToUserSuccess: [],
  deleteCompanyToUserLoading: false,

  //company to user lock user
  companyToUserLockUser: [],
  companyToUserLockUserLoading: false,
  companyToUserResetPassword: [],
  companyToUserResetPasswordLoading: false,
  companyToUserUnlockUser: [],
  companyToUserUnlockUserLoading: false,

  //company to user update subscription licence and security
  companyToUserUpdateSubscriptionLicenceAndSecurity: [],
  companyToUserUpdateSubscriptionLicenceAndSecurityLoading: false,

  //company to user data
  companyToUserData: [],
  companyToUserDataLoading: false,
};

const CompanyToUser = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANY_TO_USER_LIST:
      return {
        ...state,
        getCompanySwitchListLoading: true,
      };
    case GET_COMPANY_TO_USER_LIST_SUCCESS:
      return {
        ...state,
        companyToUserList: action.payload,
        getCompanySwitchListLoading: false,
      };
    case GET_COMPANY_TO_USER_LIST_FAILURE:
      return {
        ...state,
        getCompanySwitchListLoading: false,
      };
    case SWITCH_COMPANY:
      return {
        ...state,
      };
    case SWITCH_COMPANY_SUCCESS:
      return {
        ...state,
        companySwitch: action.payload,
      };
    case SWITCH_COMPANY_FAILURE:
      return {
        ...state,
        companySwitch: action.payload,
      };
    case GET_COMPANY_USER_INVITATIONS:
      return {
        ...state,
      };
    case GET_COMPANY_USER_INVITATIONS_SUCCESS:
      return {
        ...state,
        companyUserInvitations: action.payload,
      };
    case GET_COMPANY_USER_INVITATIONS_FAILURE:
      return {
        ...state,
      };
    case SEND_EMAIL_INVITATION:
      return {
        ...state,
        sendUserInviteSuccessLoading: true,
      };
    case SEND_EMAIL_INVITATION_SUCCESS:
      return {
        ...state,
        sendUserInviteSuccess: action.payload,
        sendUserInviteSuccessLoading: false,
      };
    case SEND_EMAIL_INVITATION_FAILURE:
      return {
        ...state,
        sendUserInviteSuccessLoading: false,
      };
    case GET_JOIN_COMPANY_INVITATION_LIST:
      return {
        ...state,
        joinCompanyInvitationListLoading: true,
      };
    case GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS:
      return {
        ...state,
        joinCompanyInvitationList: action.payload,
        joinCompanyInvitationListLoading: false,
      };
    case GET_JOIN_COMPANY_INVITATION_LIST_FAILURE:
      return {
        ...state,
        joinCompanyInvitationListLoading: false,
      };
    case ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY:
      return {
        ...state,
        acceptOrDeclineInvitationToJoinCompanyLoading: true,
      };
    case ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS:
      return {
        ...state,
        acceptOrDeclineInvitationToJoinCompany: action.payload,
        acceptOrDeclineInvitationToJoinCompanyLoading: false,
      };
    case ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE:
      return {
        ...state,
        acceptOrDeclineInvitationToJoinCompanyLoading: false,
      };
    case GET_COMPANY_TEAM_MEMBERS_LIST:
      return {
        ...state,
        companyTeamMembersListLoading: true,
      };
    case GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS:
      return {
        ...state,
        companyTeamMembersList: action.payload,
        companyTeamMembersListLoading: false,
      };
    case GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE:
      return {
        ...state,
        companyTeamMembersListLoading: false,
      };
    case GET_COMPANY_DETAILS:
      return { ...state, companyDetailsLoading: true };
    case GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetails: action.payload,
        companyDetailsLoading: false,
      };
    case GET_COMPANY_DETAILS_FAILURE:
      return { ...state, companyDetailsLoading: false };
    case UPDATE_COMPANY_DETAILS:
      return { ...state, updateCompanyDetailsLoading: true };
    case UPDATE_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        updateCompanyDetailsSuccess: action.payload,
        updateCompanyDetailsLoading: false,
      };
    case UPDATE_COMPANY_DETAILS_FAILURE:
      return { ...state, updateCompanyDetailsLoading: false };
    case GET_USER_AVAILABLE_MENU:
      return { ...state, userAvailableMenuLoading: true };
    case GET_USER_AVAILABLE_MENU_SUCCESS:
      return {
        ...state,
        userAvailableMenu: action.payload,
        userAvailableMenuLoading: false,
      };
    case GET_USER_AVAILABLE_MENU_FAILURE:
      return { ...state, userAvailableMenuLoading: false };
    case GET_USER_AVAILABLE_DASHBOARD:
      return { ...state, userAvailableDashboardLoading: true };
    case GET_USER_AVAILABLE_DASHBOARD_SUCCESS:
      return {
        ...state,
        userAvailableDashboard: action.payload,
        userAvailableDashboardLoading: false,
      };
    case GET_USER_AVAILABLE_DASHBOARD_FAILURE:
      return { ...state, userAvailableDashboardLoading: false };
    case MAP_DASHBOARD_AND_MENU_TO_USER:
      return { ...state, mapDashboardAndMenuToUserLoading: true };
    case MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS:
      return {
        ...state,
        mapDashboardAndMenuToUser: action.payload,
        mapDashboardAndMenuToUserLoading: false,
      };
    case MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE:
      return { ...state, mapDashboardAndMenuToUserLoading: false };
    case GET_COMPANY_TO_USER_LIST_TEAM:
      return { ...state, getCompanyToUserListTeamLoading: true };
    case GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS:
      return {
        ...state,
        getCompanyToUserListTeam: action.payload,
        getCompanyToUserListTeamLoading: false,
      };
    case GET_COMPANY_TO_USER_LIST_TEAM_FAILURE:
      return { ...state, getCompanyToUserListTeamLoading: false };
    case CREATE_COMPANY_TO_USER:
      return { ...state, createCompanyToUserLoading: true };
    case CREATE_COMPANY_TO_USER_SUCCESS:
      return {
        ...state,
        createCompanyToUserSuccess: action.payload,
        createCompanyToUserLoading: false,
      };
    case CREATE_COMPANY_TO_USER_FAILURE:
      return { ...state, createCompanyToUserLoading: false };
    case UPDATE_COMPANY_TO_USER_TEAM:
      return { ...state, updateCompanyToUserTeamLoading: true };
    case UPDATE_COMPANY_TO_USER_TEAM_SUCCESS:
      return {
        ...state,
        updateCompanyToUserTeamSuccess: action.payload,
        updateCompanyToUserTeamLoading: false,
      };
    case UPDATE_COMPANY_TO_USER_TEAM_FAILURE:
      return { ...state, updateCompanyToUserTeamLoading: false };
    case DELETE_COMPANY_TO_USER:
      return { ...state, deleteCompanyToUserLoading: true };
    case DELETE_COMPANY_TO_USER_SUCCESS:
      return {
        ...state,
        deleteCompanyToUserSuccess: action.payload,
        deleteCompanyToUserLoading: false,
      };
    case DELETE_COMPANY_TO_USER_FAILURE:
      return { ...state, deleteCompanyToUserLoading: false };
    case COMPANY_TO_USER_LOCK_USER:
      return { ...state, companyToUserLockUserLoading: true };
    case COMPANY_TO_USER_LOCK_USER_SUCCESS:
      return {
        ...state,
        companyToUserLockUser: action.payload,
        companyToUserLockUserLoading: false,
      };
    case COMPANY_TO_USER_LOCK_USER_FAILURE:
      return { ...state, companyToUserLockUserLoading: false };
    case COMPANY_TO_USER_UNLOCK_USER:
      return { ...state, companyToUserUnlockUserLoading: true };
    case COMPANY_TO_USER_UNLOCK_USER_SUCCESS:
      return {
        ...state,
        companyToUserUnlockUser: action.payload,
        companyToUserUnlockUserLoading: false,
      };
    case COMPANY_TO_USER_UNLOCK_USER_FAILURE:
      return { ...state, companyToUserUnlockUserLoading: false };
    case COMPANY_TO_USER_RESET_PASSWORD:
      return { ...state, companyToUserResetPasswordLoading: true };
    case COMPANY_TO_USER_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        companyToUserResetPassword: action.payload,
        companyToUserResetPasswordLoading: false,
      };
    case COMPANY_TO_USER_RESET_PASSWORD_FAILURE:
      return { ...state, companyToUserResetPasswordLoading: false };
    case COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY:
      return {
        ...state,
        companyToUserUpdateSubscriptionLicenceAndSecurityLoading: true,
      };
    case COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS:
      return {
        ...state,
        companyToUserUpdateSubscriptionLicenceAndSecurity: action.payload,
        companyToUserUpdateSubscriptionLicenceAndSecurityLoading: false,
      };
    case COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE:
      return {
        ...state,
        companyToUserUpdateSubscriptionLicenceAndSecurityLoading: false,
      };
    case GET_COMPANY_TO_USER_DATA:
      return { ...state, companyToUserDataLoading: true };
    case GET_COMPANY_TO_USER_DATA_SUCCESS:
      return {
        ...state,
        companyToUserData: action.payload,
        companyToUserDataLoading: false,
      };
    case GET_COMPANY_TO_USER_DATA_FAILURE:
      return { ...state, companyToUserDataLoading: false };

    default:
      return state;
  }
};

export default CompanyToUser;
